// src/components/TripDetail.tsx
import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import TripDetailHero from './TripDetailHero';
import TripIterinary from "./TripIterinary";
import TripHighlightsAndInfo from "./TripHighlightsAndInfo";
import ReviewsSection from "./ReviewsSection";
import BookNowCTA from "../trip-two/BookNowCTA";
import VanTransport from "../components/VanTransport";

// Styled Components
const TripContainer = styled.div`
    min-height: 100vh;
    background: #ffffff;
    color: #1a1a1a;
`;

// Main TripDetail Component
interface TripDetailProps {
    onNavigateBack: () => void;
    onNavigateToContact: () => void;
}

const TripDetail: React.FC<TripDetailProps> = ({ onNavigateBack, onNavigateToContact }) => {
    const handleBookNow = () => {
        alert("Booking inquiry sent! We'll contact you shortly to confirm your tour details.");
    };

    return (
        <TripContainer>
            {/* TripDetailHero Section */}
            <TripDetailHero onNavigateBack={onNavigateBack} />
            <TripIterinary  />
            <BookNowCTA />

            <TripHighlightsAndInfo />
            <VanTransport />

            <BookNowCTA />
            <ReviewsSection />

        </TripContainer>
    );
};

export default TripDetail;